// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { drawDOM, exportPDF } from '@progress/kendo-drawing';
import { saveAs } from '@progress/kendo-file-saver';
import KendoDrawingAdapter from './KendoDrawingAdapter';
import { getDefaultSlots, validatePackage } from '@progress/kendo-vue-common';
import { packageMetadata } from './package-metadata';
/**
 * @hidden
 */
var PDFExportVue2 = {
  name: 'pdf-export',
  props: {
    author: String,
    avoidLinks: [Boolean, String],
    forcePageBreak: String,
    keepTogether: String,
    creator: String,
    date: Date,
    imageResolution: Number,
    fileName: String,
    forceProxy: Boolean,
    keywords: String,
    landscape: Boolean,
    margin: [String, Object],
    pageTemplate: [Object, Function],
    paperSize: [String, Object],
    repeatHeaders: Boolean,
    scale: Number,
    proxyData: Object,
    proxyURL: String,
    proxyTarget: String,
    producer: String,
    subject: String,
    title: String
  },
  methods: {
    save: function save(callback) {
      new KendoDrawingAdapter(drawDOM, exportPDF, saveAs, this.$el,
      // To do: we should consider whether we need a margin-top, margin-left, etc. props
      this.$props).savePDF(callback);
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  created: function created() {
    validatePackage(packageMetadata);
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var defaultSlot = getDefaultSlots(this);
    return h("div", [defaultSlot]);
  }
  // To do: we should consider whether we need a margin-top, margin-left, etc. props
  // private getOptions() {
  //     return Object.assign({}, this.$props, { margin: getPageMrgin(this.$props) });
  // }
};
/**
 * @hidden
 */
var PDFExport = PDFExportVue2;
export { PDFExport, PDFExportVue2 };